import { Fragment, ReactElement } from 'react';
import DetailNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const DetailNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <DetailNotificationsCivilStatusShared scope={IdAmbito.Mutazioni} />
    </Fragment>
  );
};

DetailNotificationsCivilStatusPage.displayName = 'Detail Notifications Civil Status component';

export default DetailNotificationsCivilStatusPage;
